import { LandingTemplate } from "@/components/LandingTemplate";

export default function JobTrackerPage() {
  return (
    <LandingTemplate
      testid="job-tracker-landing"
      eyebrow="Free Job Tracker"
      h1="Free Job Application Tracker — From Applied to Offer"
      sub="Stop losing track of where you applied. Zuntria's free job application tracker follows every application through Applied, Interview and Offer — with WhatsApp reminders the day before every interview so you never miss one."
      cta="Track my applications free"
      ctaTo="/signup"
      bullets={[
        { title: "Every stage, tracked", text: "Saved → Preparing → Applied → Interview → Offer. See your whole pipeline and momentum at a glance." },
        { title: "Interview reminders", text: "Set the interview date and get an in-app + WhatsApp nudge the day before and the morning of — automatically." },
        { title: "Works with your CV", text: "Build your CV in Zuntria, apply on LinkedIn, Indeed or Reed, then log the application in one tap." },
        { title: "Honest statuses", text: "Zuntria never fakes progress — you always know exactly what's applied, pending and won." },
      ]}
      steps={[
        "Create a free account and open the Job Tracker.",
        "Log each application with company, role and platform.",
        "Move applications through stages as you hear back.",
        "Add interview dates — Zuntria reminds you before every one.",
      ]}
      faqs={[
        { q: "Is the job application tracker free?", a: "Yes — tracking applications, stages and interview dates is completely free on Zuntria." },
        { q: "How do the interview reminders work?", a: "When an application reaches the Interview stage, set the date. Zuntria sends an in-app notification and a WhatsApp message the day before and the morning of your interview." },
        { q: "Why should I track my job applications?", a: "Applicants who track follow up more, prepare better and convert more interviews. A tracked pipeline shows you what's working — which platforms, which CV versions — so every week gets stronger." },
        { q: "Can I track applications from any job board?", a: "Yes — LinkedIn, Indeed, Reed, TotalJobs, Contra, company sites, or word of mouth. Log anything and manage it in one place." },
      ]}
    />
  );
}
